// theme.js
import { createTheme } from "@mui/material/styles";

const textFieldTheme = createTheme({
  palette: {
    primary: { main: "#4CAF50" },
    background: { default: "#F1F8F4" },
  },
  components: {
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
        fullWidth: true,
        size: "small",
      },
    },

    
  },
  
});

export default textFieldTheme;
